/* ============================================================================
   PRESSROOM — FOOTER "Lights Off" davranisi (FAZ 2 Parti 3, spec 3.11)
   <pressroom-footer> web component.

   Dev wordmark gorununce alttan yukselir: tek IntersectionObserver, .is-risen.
   will-change yalniz animasyon suresince eklenir, bitince kaldirilir (GPU
   bellek sizmasi yok). reduced-motion: hicbir gelistirme — wordmark statik
   (CSS zaten son durumu veriyor).

   Hardcoded yok: --d-slow token'dan okunur (will-change kaldirma zamani).
   ============================================================================ */
(function () {
  'use strict';

  if (!('customElements' in window)) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function readToken(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  }
  function toMs(token, fallbackMs) {
    if (!token) return fallbackMs;
    if (token.indexOf('ms') !== -1) return parseFloat(token);
    if (token.indexOf('s') !== -1) return parseFloat(token) * 1000;
    var n = parseFloat(token);
    return isNaN(n) ? fallbackMs : n;
  }

  customElements.define('pressroom-footer', class extends HTMLElement {
    connectedCallback() {
      this._wordmark = this.querySelector('[data-pr-footer-wordmark]');
      if (!this._wordmark) return;

      // reduced-motion: CSS son durumu veriyor; gelistirme yok.
      if (REDUCED) return;

      if (!('IntersectionObserver' in window)) {
        this._wordmark.classList.add('is-risen');
        return;
      }

      this._riseMs = toMs(readToken('--d-slow'), 720);
      this._io = new IntersectionObserver(this._onIntersect.bind(this), {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.2
      });
      this._io.observe(this._wordmark);
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      if (this._wcTimer) clearTimeout(this._wcTimer);
    }

    _onIntersect(entries, obs) {
      if (!entries[0].isIntersecting || this._done) return;
      this._done = true;
      obs.unobserve(this._wordmark);

      // will-change yalniz animasyon suresince
      this._wordmark.style.willChange = 'transform, opacity';
      this._wordmark.classList.add('is-risen');

      var self = this;
      this._wcTimer = setTimeout(function () {
        self._wordmark.style.willChange = 'auto';
      }, this._riseMs + 50);
    }
  });
})();
